__turbopack_context__.v({
  "image": "MediaImage-module__B0fEDG__image",
});
